import { useSearchParams } from 'react-router-dom';

export function defaultPeriod(): string {
  const now = new Date(new Date().toLocaleString('en-US', { timeZone: 'America/Chicago' }));
  now.setDate(1);
  now.setMonth(now.getMonth() - 1);
  return `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}`;
}

/** Period kept in the URL (?period=YYYY-MM) so it survives navigation between stages. */
export function usePeriod(): [string, (p: string) => void] {
  const [params, setParams] = useSearchParams();
  const period = params.get('period') ?? defaultPeriod();
  return [period, (p) => setParams({ period: p }, { replace: true })];
}

export default function PeriodPicker({ value, onChange }: { value: string; onChange: (p: string) => void }) {
  return (
    <label className="text-sm inline-flex items-center gap-2">
      <span className="font-semibold">Period</span>
      <input type="month" className="border border-allstar-gray rounded px-3 py-1.5" value={value}
        onChange={(e) => e.target.value && onChange(e.target.value)} />
    </label>
  );
}
